<template>
  <div>
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center py-10>
      <v-flex xs12 sm11 md10 lg8>
        <v-card elevation="0" outlined class="rounded-lg overflow-hidden" style="background-color: #ffffff; border-color: #e0e0e0;">
          <!-- Header Section -->
          <div style="padding: 24px 30px; border-bottom: 1px solid #eeeeee;">
            <v-layout align-center>
              <v-flex>
                <h2 style="font-family: kumbhBold; font-size: 24px; color: #333; margin: 0; display: flex; align-items: center; gap: 10px;">
                  <v-icon color="#005f32">mdi-airplane-takeoff</v-icon> Apply for Travel
                </h2>
                <p style="font-family: kumbhRegular; font-size: 14px; color: #666; margin-top: 4px; margin-bottom: 0;">Submit your travel request by filling the details below</p>
              </v-flex>
            </v-layout>
          </div>

          <div style="padding: 30px;">
            <v-layout wrap>
                <v-flex xs12 sm6 class="pr-sm-3 mb-5">
                  <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Source</div>
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="travelData.source"
                    prepend-inner-icon="mdi-map-marker-outline"
                    placeholder="Enter Source"
                  ></v-text-field>
                </v-flex>
                
                <v-flex xs12 sm6 class="pl-sm-3 mb-5">
                  <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Destination</div>
                  <v-text-field
                    outlined
                    dense
                    hide-details
                    v-model="travelData.destination"
                    prepend-inner-icon="mdi-map-marker-radius-outline"
                    placeholder="Enter Destination"
                  ></v-text-field>
                </v-flex>
                
                <v-flex xs12 class="mb-5">
                  <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Mode of Travel</div>
                  <v-select
                    v-model="travelData.travelMode"
                    :items="travelModes"
                    dense
                    outlined
                    hide-details
                    prepend-inner-icon="mdi-bus-double-decker"
                    placeholder="Select Mode of Travel"
                  ></v-select>
                </v-flex>
                
                <v-flex xs12 class="mb-5">
                  <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Description</div>
                  <v-textarea
                    v-model="travelData.description"
                    outlined
                    dense
                    rows="4"
                    hide-details
                    placeholder="Please provide a brief description for your travel request..."
                  ></v-textarea>
                </v-flex>

              <!-- Dates Section -->
              <v-flex xs12 class="mb-5">
                <div style="font-family: kumbhBold; font-size: 16px; color: #333; margin-bottom: 8px;">Travel Dates & Time</div>
                <v-card outlined class="pa-5 rounded-lg" style="background-color: #fafafa; border: 1px solid #e0e0e0;">
                  <v-layout wrap>
                    <v-flex xs12 sm6 class="pr-sm-3 mb-4 mb-sm-0">
                      <div style="font-family: kumbhRegular; font-size: 14px; color: #555; margin-bottom: 5px;">Start Date</div>
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="startDate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="computedDateFormattedFrom"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                            background-color="white"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="startDate"
                          no-title
                          scrollable
                          color="#005f32"
                          :min="minDateStart"
                          @change="checkDateTime()"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="#005f32" @click="menu = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="#005f32"
                            @click="$refs.menu.save(startDate)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm6 class="pl-sm-3">
                      <div style="font-family: kumbhRegular; font-size: 14px; color: #555; margin-bottom: 5px;">Start Time</div>
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="startTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="startTime"
                            prepend-inner-icon="mdi-clock-time-four-outline"
                            readonly
                            outlined
                            dense
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                            background-color="white"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu2"
                          v-model="startTime"
                          full-width
                          color="#005f32"
                          @change="checkDateTime()"
                          @click:minute="$refs.menu2.save(startTime)"
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm6 class="pr-sm-3 mt-4">
                      <div style="font-family: kumbhRegular; font-size: 14px; color: #555; margin-bottom: 5px;">End Date</div>
                      <v-menu
                        ref="menu3"
                        v-model="menu3"
                        :close-on-content-click="false"
                        :return-value.sync="endDate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="computedDateFormattedTo"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            outlined
                            dense
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                            background-color="white"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="endDate"
                          no-title
                          scrollable
                          color="#005f32"
                          :min="minDate"
                          @change="checkDateTime()"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="#005f32" @click="menu3 = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="#005f32"
                            @click="$refs.menu3.save(endDate)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-flex>

                    <v-flex xs12 sm6 class="pl-sm-3 mt-4">
                      <div style="font-family: kumbhRegular; font-size: 14px; color: #555; margin-bottom: 5px;">End Time</div>
                      <v-menu
                        ref="menu4"
                        v-model="menu4"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="endTime"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="endTime"
                            prepend-inner-icon="mdi-clock-time-four-outline"
                            readonly
                            outlined
                            dense
                            hide-details
                            v-bind="attrs"
                            v-on="on"
                            background-color="white"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menu4"
                          v-model="endTime"
                          full-width
                          color="#005f32"
                          @change="checkDateTime()"
                          @click:minute="$refs.menu4.save(endTime)"
                        ></v-time-picker>
                      </v-menu>
                    </v-flex>

                  </v-layout>
                </v-card>
              </v-flex>

              <!-- Submit Button -->
              <v-flex xs12 class="mt-2">
                <v-btn block color="#005f32" dark x-large class="rounded-lg elevation-3" @click="validateInput()" style="font-family: kumbhBold; font-size: 18px; letter-spacing: 1px; text-transform: none;">
                  <v-icon left>mdi-send-check</v-icon> Submit Travel Request
                </v-btn>
              </v-flex>

            </v-layout>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
  <script>
import axios from "axios";
export default {
  data() {
    return {
      visible: false,
      showsnackbar: false,
      multi: true,
      orgId: localStorage.getItem("orgid"),
      userId: localStorage.getItem("userid"),
      disabledDates: {
        to: new Date(Date.now() - 8640000),
      },
      startDate:new Date().toISOString().split("T")[0],
      endDate:new Date().toISOString().split("T")[0],
      startTime: "",
      endTime: "",
      appliedBy: "me",
      appliedFor: null,
      message: "",
      msg: "",
      travelData: {
        id: null,
        source: null,
        destination: null,
        description: null,
        travelMode: null,
      },
      travelModes: [],
      isDateCorrect: true,
      dates: [],
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      minDateStart: new Date().toISOString().split("T")[0], // Format date to YYYY-MM-DD
      minDate: new Date().toISOString().split("T")[0], // Format date to YYYY-MM-DD
    };
  },
  computed: {
    computedDateFormattedFrom() {
      return this.formatDatePicker(this.startDate);
    },
    computedDateFormattedTo() {
      return this.formatDatePicker(this.endDate);
    },
  },
  // watch: {
  //   startDate(newStartDate) {
  //     if (newStartDate) {
  //       const newMinDate = new Date(newStartDate).toISOString().split("T")[0];
  //       this.minDate = newMinDate;

  //       // Clear endDate if it's before the new startDate
  //       if (this.endDate && new Date(this.endDate) < new Date(newStartDate)) {
  //         this.endDate = null;
  //       }
  //     }
  //   },
  // },
  mounted: function () {
    this.getData();
    this.getTravelMode();
  },
  methods: {
    checkDateTime() {
      if (this.startDate && this.endDate && this.startTime && this.endTime) {
        var startDateTime = new Date(this.startDate);
        var endDateTime = new Date(this.endDate);
        var sTime = this.startTime.split(":");
        var eTime = this.endTime.split(":");
        startDateTime.setHours(sTime[0], sTime[1], 0, 0);
        endDateTime.setHours(eTime[0], eTime[1], 0, 0);

        if (startDateTime.getTime() >= endDateTime.getTime()) {
          this.msg =
            "Please ensure the end date and time is after the start date and time";
          this.showsnackbar = true;
        }
      }
    },
    validateInput() {
      if (!this.travelData.source) {
        this.msg = "Please provide source";
        this.showsnackbar = true;
        return;
      } else if (!this.travelData.destination) {
        this.msg = "Please provide destination";
        this.showsnackbar = true;
        return;
      } else if (!this.travelData.travelMode) {
        this.msg = "Please select travel mode";
        this.showsnackbar = true;
        return;
      } else if (!this.startDate) {
        this.msg = "Please select start Date";
        this.showsnackbar = true;
        return;
      } else if (!this.endDate) {
        this.msg = "Please select end date";
        this.showsnackbar = true;
        return;
      } else if (!this.startTime) {
        this.msg = "Please select start time";
        this.showsnackbar = true;
        return;
      } else if (!this.endTime) {
        this.msg = "Please select end time";
        this.showsnackbar = true;
        return;
      } else if (
        this.startDate && this.endDate && this.startTime && this.endTime
      ) {
        var startDateTime = new Date(this.startDate);
        var endDateTime = new Date(this.endDate);
        var sTime = this.startTime.split(":");
        var eTime = this.endTime.split(":");
        startDateTime.setHours(sTime[0], sTime[1], 0, 0);
        endDateTime.setHours(eTime[0], eTime[1], 0, 0);

        if (startDateTime.getTime() >= endDateTime.getTime()) {
          this.msg =
            "Please ensure the end date and time is after the start date and time.";
          this.showsnackbar = true;
        }
        else {
        this.applyLeave();
      }
      } else {
        this.applyLeave();
      }
    },
    formatDate(date) {
      return date.toLocaleDateString();
    },
    getTravelMode() {
      axios({
        method: "GET",
        url: "/travelMode/list",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status) {
            this.travelModes = response.data.data;
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((e) => {
          this.visible = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    getData() {
      this.visible = true;
      axios({
        method: "GET",
        url: "/travelLog/view/" + this.$route.query.id,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.visible = false;
            this.travelData = response.data.data;
            this.startDate = this.travelData.startingTime.slice(0, 10);
            this.endDate = this.travelData.endingTime.slice(0, 10);
            this.startTime = this.convertUTCToLocal(
              this.travelData.startingTime
            );
            this.endTime = this.convertUTCToLocal(this.travelData.endingTime);
            this.status = response.data.data.status;
          } else if (response.data.status === false) {
            alert(response.data.msg);
            this.$router.go(-1);
          }
        })
        .catch((e) => {
          this.visible = false;
          this.errors.push(e);
          this.msg = "failed";
        });
    },
    applyLeave() {
      var url;
      if (this.$route.query.type == "edit") {
        url = "/travelLog/edit";
        this.travelData.id = this.$route.query.id;
        this.travelData.startingTime = `${this.startDate} ${this.startTime}`;
        this.travelData.endingTime = `${this.endDate} ${this.endTime}`;
      } else {
        this.travelData.startingTime = `${this.startDate} ${this.startTime}`;
        this.travelData.endingTime = `${this.endDate} ${this.endTime}`;
        url = "/travelLog/add";
      }

      axios({
        method: "POST",
        url: url,
        data: this.travelData,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status === true) {
            this.getData();
            this.msg = response.data.msg;
            this.showsnackbar = true;
            this.$router.push({ name: "myTravelogue" });
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.visible = false;
          if (err.response.data.status === false) {
            this.msg = "Please Try Again";
          }
        });
    },
    convertUTCToLocal(utcDateString) {
      // Create a new Date object from the UTC date string
      var utcDate = new Date(utcDateString);
      const hours = utcDate.getHours();
      const minutes = utcDate.getMinutes().toString().padStart(2, "0");
      const adjustedHours = hours % 12 || 12;
      const formattedTime = `${adjustedHours}:${minutes}`;
      return formattedTime;
    },
    formatDatePicker(date) {
      var dt = new Date(date);
      var day = String(dt.getDate()).padStart(2, "0"); // Ensure two digits
      var month = String(dt.getMonth() + 1).padStart(2, "0"); // Ensure two digits
      var year = dt.getFullYear();
      var strTime = day + "-" + month + "-" + year;
      return strTime;
    },
  },
};
</script>
  <style >
.selected-date {
  /* cursor: pointer; */
  min-height: 30x !important;
  max-width: 100% !important;
}
</style>
  